import axios from "../assets/api/serve.js";

//视频推流
export function pushStream(params)
{
	return axios.post("/portal/device/pushStream",params)
}

//获取视频列表
export function getMonitorInfo(params)
{
	return axios.get(`/portal/suyuan/getMonitorInfo/${params}`)
}